import _definePage_default_0 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/index/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/[...path].vue?definePage&vue'
import _definePage_default_3 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/auth/login.vue?definePage&vue'
import _definePage_default_4 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/auth/register.vue?definePage&vue'
import _definePage_default_5 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/auth/reset-pass.vue?definePage&vue'
import _definePage_default_6 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/auth.vue?definePage&vue'
import _definePage_default_7 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/reports/index.vue?definePage&vue'
import _definePage_default_8 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/rides/index.vue?definePage&vue'
import _definePage_default_9 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/rides/[id].vue?definePage&vue'
import _definePage_default_10 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/statistics/index.vue?definePage&vue'
import _definePage_default_11 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/taxi/index.vue?definePage&vue'
import _definePage_default_12 from '/home/user/Projects/enon/taxi-admin-panel/src/pages/taxi/[id].vue?definePage&vue'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/index.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'HomePage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/index/index.vue'),
        /* no children */
      },
  _definePage_default_0
  ),
      {
        path: 'reportsComp',
        name: '//reportsComp',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/index/reportsComp.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/:path(.*)',
    name: 'CatchAllPage',
    component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/[...path].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/auth',
    name: 'AuthPage',
    component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/auth.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'LoginPage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/auth/login.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'register',
        name: 'RegisterPage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/auth/register.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
  _mergeRouteRecord(
      {
        path: 'reset-pass',
        name: 'ResetPass',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/auth/reset-pass.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
  },
  _definePage_default_6
  ),
  {
    path: '/reports',
    name: '/reports',
    component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/reports.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'ReportsPage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/reports/index.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
      {
        path: 'ReportsTable',
        name: '/reports/ReportsTable',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/reports/ReportsTable.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/rides',
    name: '/rides',
    component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/rides.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'RidesPage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/rides/index.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'SingleRidePage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/rides/[id].vue'),
        /* no children */
      },
  _definePage_default_9
  )
    ],
  },
  {
    path: '/statistics',
    name: '/statistics',
    component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/statistics.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'StatisticsPage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/statistics/index.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/taxi',
    name: '/taxi',
    component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/taxi.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'TaxiPage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/taxi/index.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'SingleTaxiPage',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/taxi/[id].vue'),
        /* no children */
      },
  _definePage_default_12
  ),
      {
        path: 'AddSubModal',
        name: '/taxi/AddSubModal',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/taxi/AddSubModal.vue'),
        /* no children */
      },
      {
        path: 'EditTaxiModal',
        name: '/taxi/EditTaxiModal',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/taxi/EditTaxiModal.vue'),
        /* no children */
      },
      {
        path: 'tableRow',
        name: '/taxi/tableRow',
        component: () => import('/home/user/Projects/enon/taxi-admin-panel/src/pages/taxi/tableRow.vue'),
        /* no children */
      }
    ],
  }
]
